import { Suspense, lazy } from 'react'
import { Navigate, Route, Routes } from 'react-router-dom'

import { ProtectedLayout } from '@/components/ProtectedLayout'
import { AuthProvider } from '@/lib/auth/AuthProvider'
import { Login } from '@/pages/Login'
import { Company } from '@/pages/company/Company'
import { CompanyIndex } from '@/pages/company/CompanyIndex'
import { Files } from '@/pages/files/Files'
import { Portfolio } from '@/pages/portfolio/Portfolio'

const Admin = lazy(() => import('@/pages/admin').then((m) => ({ default: m.Admin })))
const ManageCompanies = lazy(() =>
  import('@/pages/admin').then((m) => ({ default: m.ManageCompanies })),
)
const AdminUsers = lazy(() => import('@/pages/admin').then((m) => ({ default: m.AdminUsers })))

const AskAI = lazy(() => import('@/pages/ask-ai').then((m) => ({ default: m.AskAI })))
const Styleguide = lazy(() => import('@/dev/Styleguide').then((m) => ({ default: m.Styleguide })))

function PageFallback() {
  return (
    <div className="canopy-page" style={{ color: 'var(--text-3)' }}>
      Loading…
    </div>
  )
}

export function App() {
  return (
    <AuthProvider>
      <Routes>
        <Route path="/login" element={<Login />} />

        <Route
          path="/dev/styleguide"
          element={
            <Suspense fallback={<PageFallback />}>
              <Styleguide />
            </Suspense>
          }
        />

        <Route element={<ProtectedLayout />}>
          <Route index element={<Portfolio />} />
          <Route path="company" element={<CompanyIndex />} />
          <Route path="company/:companyId" element={<Company />} />
          <Route path="admin" element={<Admin />} />
          <Route path="admin/companies" element={<ManageCompanies />} />
          <Route path="admin/users" element={<AdminUsers />} />
          <Route path="files" element={<Files />} />
          <Route path="ask-ai" element={<AskAI />} />
        </Route>

        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </AuthProvider>
  )
}
